import { useEffect, useRef, useState } from "react";
import Tippy from "@tippyjs/react";
import styles from "./LongTextCell.module.scss";

export function LongTextCell({ text }: { text: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const measure = () => {
      setIsTruncated(
        element.scrollHeight > element.clientHeight ||
          element.scrollWidth > element.clientWidth,
      );
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text]);

  return (
    <Tippy
      content={<div className={styles.fullText}>{text}</div>}
      disabled={!isTruncated}
      interactive
      maxWidth={480}
      delay={[400, 100]}
      appendTo={document.body}
      zIndex={999999}
    >
      <div
        ref={ref}
        className={styles.preview}
        tabIndex={isTruncated ? 0 : undefined}
      >
        {text}
      </div>
    </Tippy>
  );
}
